import { FC } from 'react';
import { Box } from '@chakra-ui/react';

type Props = {
  label: string;
  backgroundColor: string;
};

export const DisplayStatusBadgeView: FC<Props> = ({
  label,
  backgroundColor,
}) => (
  <Box
    as="span"
    w="70px"
    textAlign="center"
    display="inline-block"
    p="0.2em 0.9em"
    fontSize="0.75rem"
    fontWeight="bold"
    color="white"
    bgColor={backgroundColor}
    borderRadius="1em"
  >
    {label}
  </Box>
);
